import type { RequestContext } from '#shared/lib/context';
import { REQUEST_CONTEXT_ID } from './context/const';

// Первый entry меняет publicPath до импортов, которые вычисляют URL ассетов при загрузке модуля.
// Локальных URL в HTML недостаточно: ленивые JS/CSS и ассеты иначе продолжат загружаться с CDN.
if (!__IS_LOCAL__) {
    const contextElement = document.getElementById(REQUEST_CONTEXT_ID);
    const requestContext: Pick<RequestContext, 'staticDelivery'> = contextElement?.textContent
        ? JSON.parse(contextElement.textContent)
        : {};

    if (requestContext?.staticDelivery === 'local') {
        __webpack_public_path__ = __LOCAL_STATIC_PUBLIC_PATH__;
    }
}
